import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function VisionSection() {
  const points = ['Your lawn is freshly cut and beautifully edged.', 'Your flower beds are blooming and perfectly shaped.', 'Your gutters are clear and your home is protected.', 'That old pile of junk? Gone.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-261">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-262"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-263"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-264">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-brand-dark rounded-3xl p-8 md:p-12 shadow-xl shadow-brand-gold/5 border border-brand-gold/20" data-id="element-265">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-gold mb-10 text-center" data-id="element-266">
            Picture This — Just A Few Days From Now...
          </h2>

          <div className="space-y-6 mb-10 max-w-2xl mx-auto" data-id="element-267">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2 + index * 0.1
          }} className="flex items-center gap-4" data-id="element-268">
                <CheckCircle className="text-brand-gold flex-shrink-0" size={24} data-id="element-269" />
                <p className="text-lg md:text-xl text-gray-300" data-id="element-270">{point}</p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="text-center border-t border-brand-gold/10 pt-8 mt-8" data-id="element-271">
            <p className="text-xl md:text-2xl font-medium text-white mb-4" data-id="element-272">
              And you? You're standing in your yard, coffee in hand, genuinely
              proud of the home you've built.
            </p>
            <p className="text-lg text-brand-gold font-semibold" data-id="element-273">
              All it takes is one simple call.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}